export class ReportFleet {
  placa?: string;
  chassi?: string;
  marca?: string;
  modelo?: string;
  anoFabricacao?: number;
  gpsLatitude?: string;
  gpsLongitude?: string;
  bateriaExternaTensao?: number;
  revGeoUF?: string;
  revGeoMunicipio?: string;
  revGeoBairro?: string;
  revGeoCEP?: string;
  dataHoraEvento?: string;
  origemDispositivo?: string;

  constructor() {}
}

export class ReportFleetFilter {
  modelo: [{ id: number; name: string | undefined }];
  marca: [{ id: number; name: string | undefined }];
  uf: [{ id: number; name: string | undefined }];
  municipio: [{ id: number; name: string | undefined }];
  bairro: [{ id: number; name: string | undefined }];
  constructor() {
    (this.modelo = [{ id: -1, name: undefined }]),
      (this.marca = [{ id: -1, name: undefined }]),
      (this.uf = [{ id: -1, name: undefined }]),
      (this.municipio = [{ id: -1, name: undefined }]),
      (this.bairro = [{ id: -1, name: undefined }]);
  }
}

export class ReportFleetFilterSelect {
  modelo: number[];
  marca: number[];
  uf: number[];
  municipio: number[];
  bairro: number[];
  constructor() {
    (this.modelo = []),
      (this.marca = []),
      (this.uf = []),
      (this.municipio = []),
      (this.bairro = []);
  }
}
